import {
    wrapFunctionForDatapoint as baseWrapFunctionForDatapoint,
    wrapFunctionForCoreDatapoint as baseWrapFunctionForCoreDatapoint,
} from 'owa-analytics';
import type {
    DatapointConfigWithFunctions,
    CoreDatapointConfigWithFunctions,
} from 'owa-analytics/lib/utils/extractConfig';
import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';

export function wrapFunctionForDatapoint<
    DatapointArgs extends unknown[],
    WrappedFunctionArgs extends unknown[],
    WrappedFunctionReturnType
>(
    config: Omit<DatapointConfigWithFunctions<DatapointArgs>, 'mailbox'>,
    funcToWrap: (...args: WrappedFunctionArgs) => WrappedFunctionReturnType
): (...args: WrappedFunctionArgs) => WrappedFunctionReturnType {
    return baseWrapFunctionForDatapoint(
        {
            ...config,
            mailbox: () => getUserMailboxInfo(),
        } as DatapointConfigWithFunctions<DatapointArgs>,
        funcToWrap as never
    ) as unknown as (...args: WrappedFunctionArgs) => WrappedFunctionReturnType;
}

export function wrapFunctionForCoreDatapoint<
    DatapointArgs extends unknown[],
    WrappedFunctionArgs extends unknown[],
    WrappedFunctionReturnType
>(
    config: Omit<CoreDatapointConfigWithFunctions<DatapointArgs>, 'mailbox'>,
    funcToWrap: (...args: WrappedFunctionArgs) => WrappedFunctionReturnType
): (...args: WrappedFunctionArgs) => WrappedFunctionReturnType {
    return baseWrapFunctionForCoreDatapoint(
        {
            ...config,
            mailbox: () => getUserMailboxInfo(),
        } as CoreDatapointConfigWithFunctions<DatapointArgs>,
        funcToWrap as never
    ) as unknown as (...args: WrappedFunctionArgs) => WrappedFunctionReturnType;
}
